import { useMemo, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import cn from 'classnames';

import { Dialog } from '../../Dialog';
import { OwnersItemRealty } from '../OwnersItemRealty';
import { AddContactForm } from '../../../form/forms/realtyForm/AddContactForm';
import { ButtonTemplate } from '../../buttons/ButtonTemplate';
import { AddRealtyForm } from '../../../form/forms/realtyForm/AddRealtyForm';
import { AddOwnerContactForm } from '../../../form/forms/realtyCardForms/AddOwnerContactForm';

import { mockAccordionTitles } from '../../../../data/constants';

export const OwnersRealty = ({
  realty = false,
  canEdit = false,
  canTakeover = false,
  contacts = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [contactId, setContactId] = useState(null);

  const sortedContacts = useMemo(() => {
    if (!contacts?.length) return [];
    return [...contacts].sort((a, b) => {
      const aOwner = a?.role?.value === 1 ? 0 : 1;
      const bOwner = b?.role?.value === 1 ? 0 : 1;
      return aOwner - bOwner;
    });
  }, [contacts]);

  const handleAddContactClick = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleEditContactClick = () => {
    setIsEditFormOpen(!isEditFormOpen);
  };

  return (
    <>
      <div className="relative flex flex-col items-start gap-0.5 flex-wrap w-full">
        {sortedContacts.length > 0 && (
          <div className="flex items-center flex-wrap gap-1.5 p-0.5">
            {sortedContacts.map(contact => {
              return (
                <OwnersItemRealty
                  key={contact?.id}
                  contact={contact}
                  realtyId={realty?.id}
                  handleAddContactClick={handleEditContactClick}
                  setIsEditFormOpen={setIsEditFormOpen}
                  setContactId={setContactId}
                />
              );
            })}
          </div>
        )}

        {sortedContacts.length > 1 && (
          <div
            className={cn(
              'w-full bottom-0 left-0 z-[3]',
              { absolute: !isOpen },
              { static: isOpen }
            )}
          >
            <div
              className={cn(
                'w-full h-6 bg-gradient-to-t from-white to-transparent',
                { hidden: isOpen }
              )}
            ></div>
            <div
              className={cn(
                'flex items-center justify-center w-full cursor-pointer z-[3]',
                { 'h-4 bg-whiteColor': !isOpen },
                { 'bg-transparent': isOpen }
              )}
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <ChevronUp /> : <ChevronDown />}
            </div>
          </div>
        )}
      </div>

      {realty && (canEdit || canTakeover) && (
        <ButtonTemplate
          handleClick={handleAddContactClick}
          text={'Add contact'}
          classes={'border-[1px] border-gray-200'}
          isSmall={true}
          isSmallBorder={true}
        />
      )}

      {isFormOpen && canEdit && (
        <Dialog
          content={
            <AddRealtyForm
              isEdit={true}
              realty={realty}
              accordionToOpen={mockAccordionTitles.Contacts}
              handleClose={() => setIsFormOpen(false)}
            />
          }
          classes={'w-full max-w-[768px]'}
          isOpen={isFormOpen}
          onClose={() => setIsFormOpen(false)}
        />
      )}

      {isFormOpen && !canEdit && (
        <Dialog
          content={
            <AddOwnerContactForm
              realtyId={realty.id}
              handleClose={() => setIsFormOpen(false)}
            />
          }
          isOpen={isFormOpen}
          onClose={() => setIsFormOpen(false)}
        />
      )}

      {isEditFormOpen && (
        <Dialog
          content={
            <AddContactForm
              contactId={contactId}
              isEdit={isEditFormOpen}
              handleClose={() => setIsEditFormOpen(false)}
            />
          }
          classes={'w-[290px] sm:w-[420px]'}
          isOpen={isEditFormOpen}
          onClose={() => setIsEditFormOpen(false)}
        />
      )}
    </>
  );
};
